var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"py-3"},[_c('b-row',[_c('b-col',[_c('page-title',{attrs:{"title":"Log Out"}}),_c('hr'),_c('p',[_vm._v("You have been logged out.")]),_c('b-link',{attrs:{"to":"/"}},[_vm._v("Continue")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }